<template>
    <div>
        <div id="modal-template">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-header">
                        <h4 class="text-primary"><i class="fas fa-user btn-icon-wrapper btn-icon-sm"></i> Seleccionar Concepto</h4>
                    </div>
                    <div class="modal-body">
                        <DataList url="/conceptos" :fields="fields" :rowClick="selectConcepto" :modal="true"></DataList>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" @click="cerrarModal" data-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import DataList from "@/components/layouts/DataList";
//import axios from 'axios';
export default {
    name:'ModalSeleccionarConcepto',
    components: {
        DataList,
    },
      data() {
        return {
        concepto: [],
        fields: [
            {
            name: "codigo",
            label: "",
            type: "title",
            class: "text-alternate",
            append: "-"
            },
            {
            name: "descripcion",
            label: "",
            type: "title",
            class: "text-primary",
            },
            {
            name: "tipo",
            label: "Tipo",
            type: "field",
            class: "text-secondary",
            },
        ],
        loading: false
        };
    },
    methods:{
        cerrarModal(){
            this.$emit('cerrarSelectConcepto')
        },
        selectConcepto(concepto){
            this.$emit("selectConcepto", concepto);
        }
    },
}
</script>